import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetAllAnswerOptionLibrary,
	adminGetAnswerOptionLibrary,
	adminPatchAnswerOptionLibrary,
	adminPostAnswerOptionLibrary,
	adminDeleteAnswerOptionLibrary,
	resetFocusAnswerOptionLibrary,
	initNewAnswerOptionLibrary,
} from "services/answerOptionLibrary";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Answers/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";

const schemaValidation = Yup.object().shape({
	code: Yup.string().required("Champ requis"),
	code_comment: Yup.string(),
	label: Yup.string().required("Champ requis"),
	sil_code: Yup.string().required("Champ requis"),
	group: Yup.string(),
});

class AnswersAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusAnswerOptionLibrary();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllAnswerOptionLibrary();
	};

	focusOnElement = (elt) => {
		this.props.adminGetAnswerOptionLibrary(elt);
	};

	onAddClick = () => {
		this.props.initNewAnswerOptionLibrary();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostAnswerOptionLibrary(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchAnswerOptionLibrary(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteAnswerOptionLibrary(this.props.answers.focus.data);
	};

	render() {
		let answer = this.props.answers.focus.data;
		let { focus, list } = this.props.answers;
		let newAnswerOption = answer !== null && answer.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={this.props.answers.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="RÉPONSES"
					addButtonText="Nouvelle réponse"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.code.toUpperCase()}
					groupField="group"
					focusedEltId={answer}
				/>

				<ElementFocus element={focus} list={list} entity="Réponses" icon="info">
					{answer !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: answer.id,
								code: answer.code || "",
								label: answer.label || "",
								sil_code: answer.sil_code || "",
								code_comment: answer.code_comment || "",
								group: answer.group || "",
								add_text: answer.add_text || false,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusAnswerOptionLibrary}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newAnswerOption ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newAnswerOption && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocWhiteAnswersAdmin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		answers: state.admin.answers,
	};
};

const mapDispatchToProps = {
	adminGetAllAnswerOptionLibrary,
	adminGetAnswerOptionLibrary,
	adminPatchAnswerOptionLibrary,
	adminDeleteAnswerOptionLibrary,
	resetFocusAnswerOptionLibrary,
	adminPostAnswerOptionLibrary,
	initNewAnswerOptionLibrary,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnswersAdmin);
